export function minutesToMHDConvert(value: number): string {
    if (value) {
            if (value <= 360) {
                return `${value} minutes`;
            }

            if (value > 360 && value <= 1440) {
                return formatNumber(value / 60) + ' hours'
            }

            if (value > 1440 && value < 1584) {
                return formatNumber((value / 60) / 24) + ' day';
            }

            if (value >= 1584) {
                return formatNumber((value / 60) / 24) + ' days';
            }
            
            return value.toString();
        }

        return '0';
}

function formatNumber(value: number): string {
    const truncated = Math.trunc(value * 100) / 100;
    const rounded = Math.round(truncated * 10) / 10;

    if (Math.abs(rounded - Math.round(rounded)) < 0.1) {
        return Math.round(rounded).toString();
    }

    return rounded.toFixed(1);
}

